import React from 'react';
import { useStyles } from '../Sync.styles';
import theme from '../../../../styles/theme';
import type { ExerciseSyncItemDto } from '../../../../services/redux/api/syncApi';
import clsx from 'clsx';

export type SyncItemStatusDot = 'synced' | 'notSynced' | 'unsaved';

interface SyncExerciseListItemProps {
  item: ExerciseSyncItemDto;
  selected: boolean;
  statusDot: SyncItemStatusDot;
  onSelect: () => void;
}

export function SyncExerciseListItem({
  item,
  selected,
  statusDot,
  onSelect,
}: SyncExerciseListItemProps) {
  const { classes } = useStyles(theme);
  const dotClass =
    statusDot === 'synced'
      ? classes.statusDotSynced
      : statusDot === 'unsaved'
        ? classes.statusDotUnsaved
        : classes.statusDotNotSynced;

  return (
    <div
      role="button"
      tabIndex={0}
      className={clsx(classes.listItem, selected && classes.listItemSelected)}
      onClick={onSelect}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect();
        }
      }}>
      <span className={`${classes.statusDot} ${dotClass}`} />
      <span>{item.name}</span>
    </div>
  );
}
